import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m11.3 7.3-3.37 3.36a1 1 0 1 0 1.41 1.41L11 10.41V16a1 1 0 1 0 2 0v-5.59l1.66 1.66a1 1 0 0 0 1.41-1.41l-3.36-3.37a1 1 0 0 0-1.42 0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowUpInCircle;
